var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleDown = function SvgAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 5,
    viewBox: "0 0 7 5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1.5 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212529",
    d: "M7.8650297,4.08139056 L5.17623371,7.01168165 C5.09814651,7.09678228 4.95973843,7.10762445 4.86709061,7.0358983 L4.85358796,7.024526 L2.13541383,4.0818675 C2.05703986,3.99698958 2.06841454,3.86982337 2.16081989,3.79783382 C2.20046028,3.76695148 2.25075024,3.75 2.30272853,3.75 L7.697276,3.75 C7.81844212,3.75 7.91666667,3.84022308 7.91666667,3.95151889 C7.91666667,3.99904824 7.89837718,4.04504797 7.8650297,4.08139056 Z"
  }))));
};
export default SvgAngleDown;